import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5분
      refetchOnWindowFocus: true, // 창 포커스 시 리페칭 (탭 전환 시 데이터 갱신)
      refetchOnMount: true, // 컴포넌트 마운트 시 리페칭 (페이지 이동 시 데이터 갱신)
      retry: 1,
    },
  },
});
